import $ from "jquery";
import anime from 'animejs/lib/anime.es.js';

// https://stackoverflow.com/questions/55937924/how-to-use-seek-in-anime-js-in-order-to-control-an-animation-while-scrolling



function getElementScrollPercent($element) {
  var windowS = window.scrollY;
  var windowH = window.innerHeight;
  var element = $element[0];
  var elementH = $element.height();
  var elementDistanceFromTop = window.pageYOffset + element.getBoundingClientRect().top;
  var x = windowS - elementDistanceFromTop + (windowH / 1.5);
  var y = x / elementH;
  return y;
}

$('.animation_a2da').css({'opacity': 1});

$('.animation_a2da__animation').each(function() {

  var $element = $(this);
  var played = false;
  var $animations = $(this).find('.animation');
  var timelines = [];

  $animations.each(function(){
    var $animation = $(this);

    var tl = anime.timeline({
      easing: 'linear',
      autoplay: false
    });

    var type = $animation.attr('data-animation');

    if(type == 'drops_ab30') {
      
      var $drop_one = $animation.find('.drops_ab30_drop_one');
      var $drop_two = $animation.find('.drops_ab30_drop_two');

      tl.add({
        targets: $drop_one[0],
        opacity: 0,
        duration: 50,
      })
      .add({
        targets: $drop_two[0],
        opacity: 0,
        duration: 50,
      })
      .add({
        targets: $drop_one[0],
        opacity: 1,
        duration: 350,
      })
      .add({
        targets: $drop_two[0],
        opacity: 1,
        duration: 350,
      })
      .add({
        targets: $drop_one[0],
        easing: 'easeInQuad',
        top: '50%',
        duration: 500,
      })
      .add({
        targets: $drop_two[0],
        easing: 'easeInQuad',
        top: '50%',
        duration: 500,
      }, '-=650');

    }

    if(type == 'feathers_d86f') {

      var $feather_one = $animation.find('.feathers_d86f_feather_one');
      var $feather_two = $animation.find('.feathers_d86f_feather_two');

      tl.add({
        targets: $feather_one[0],
        top: '65%',
        left: '-50%',
        rotate: 30,
        duration: 1500,
        easing: 'easeOutQuad',
      })
      .add({
        targets: $feather_two[0],
        top: '115%',
        left: '20%',
        rotate: -30,
        duration: 1500,
        easing: 'easeOutQuad',
      }, '-=1500')
      tl.add({
        targets: $feather_one[0],
        top: '140%',
        left: '-100%',
        rotate: 0,
        duration: 1500,
        easing: 'easeInQuad',
      })
      .add({
        targets: $feather_two[0],
        top: '140%',
        left: '-100%',
        rotate: 0,
        duration: 1500,
        easing: 'easeInQuad',
      }, '-=1500');

    }

    if(type == 'hearts_c0ee') {
      var $heart_one = $animation.find('.hearts_c0ee_heart_one');
      var $heart_two = $animation.find('.hearts_c0ee_heart_two');

      tl.add({
        targets: $heart_one[0],
        top: '-10%',
        left: '30%',
        rotate: 0,
        duration: 2000,
        opacity: 0,
        easing: 'easeOutSine',
      })
      .add({
        targets: $heart_two[0],
        top: '-10%',
        left: '70%',
        rotate: 0,
        duration: 2000,
        opacity: 0,
        easing: 'easeOutSine',
      }, "-=1500");
    }

    if(type == 'text_b04b') {

      var $text = $animation.find('.text_b04b_text');
      var $line_1 = $animation.find('.text_b04b_line_1 path');
      // var $line_2 = $animation.find('.text_b04b_line_2 path');

      tl.add({
        targets: $text[0],
        top: '48%',
        left: '90%',
        rotate: 2,
        duration: 2000,
        opacity: 1,
        easing: 'easeInOutSine',
      })
      .add({
        targets: $line_1[0],
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'easeInOutSine',
        duration: 500,
      })
      // .add({
      //   targets: $line_1[0],
      //   strokeDashoffset: [0, -540.838134765625],
      //   easing: 'easeInOutSine',
      //   duration: 500,
      // });

    }

    if(type == 'text_d5c9') {

      var $text = $animation.find('.text_d5c9_text');
      var $line_1 = $animation.find('.text_d5c9_line_1 path');
      // var $line_2 = $animation.find('.text_d5c9_line_2 path');

      tl.add({
        targets: $text[0],
        top: '50%',
        left: '10%',
        rotate: -90,
        duration: 10,
        opacity: 0,
        easing: 'easeInOutSine',
      })
      .add({
        targets: $text[0],
        top: '84%',
        left: '-56%',
        rotate: -6,
        duration: 2000,
        opacity: 1,
        easing: 'easeInOutSine',
      })
      .add({
        targets: $line_1[0],
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'linear',
        duration: 500,
      })
      // .add({
      //   targets: $line_2[0],
      //   strokeDashoffset: [anime.setDashoffset, 0],
      //   easing: 'linear',
      //   duration: 500,
      // }, '-=500')
      // .add({
      //   targets: $line_2[0],
      //   strokeDashoffset: [0, -109.85414123535156],
      //   easing: 'linear',
      //   duration: 500,
      // });
    }

    if(type == 'text_c851') {

      var $text = $animation.find('.text_c851_text');
      var $line_1 = $animation.find('.text_c851_line_1 path');
      var $line_2 = $animation.find('.text_c851_line_2 path');

      tl.add({
        targets: $text[0],
        top: '40%',
        left: '20%',
        rotate: 90,
        duration: 10,
        opacity: 0,
        easing: 'easeInOutSine',
      })
      .add({
        targets: $text[0],
        top: '81%',
        left: '34%',
        rotate: 4,
        duration: 2000,
        opacity: 1,
        easing: 'easeInOutSine',
      })
      .add({
        targets: $line_1[0],
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'linear',
        duration: 500,
      })
      .add({
        targets: $line_2[0],
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'linear',
        duration: 500,
      })
      .add({
        targets: $line_2[0],
        strokeDashoffset: [0, -247.1086883544922],
        easing: 'linear',
        duration: 500,
      });

    }

    if(type == 'text_e3c4') {

      var $text = $animation.find('.text_e3c4_text');
      var $line_1 = $animation.find('.text_e3c4_line_1 path');

      tl.add({
        targets: $text[0],
        top: '60%',
        left: '20%',
        duration: 10,
        opacity: 0,
        rotate: -30,
        easing: 'easeInOutSine',
      })
      .add({
        targets: $text[0],
        top: '77%',
        left: '-37%',
        duration: 2000,
        opacity: 1,
        rotate: -4,
        easing: 'easeInOutSine',
      })
      .add({
        targets: $line_1[0],
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'easeInOutSine',
        duration: 1000,
      })
    }
    

    timelines.push(tl);
  });

  $(window).on('scroll', function() {
    const scrolled = getElementScrollPercent($element);
    if(scrolled > 0.15) {
      if(!played) {
        console.log('play animation');
        timelines.forEach(tl => {
          tl.play();
        });
        played = true;
      }
    }
  });

});



$('.background-squiggles').prepend('<ul class="squiggles"><li></li><li></li><li></li><li></li><li></li><li></li></ul>');
// console.log('background-squiggles');